import React from "react";
import { useTranslation } from "react-i18next";

type MentionLegalsType = {}

export const MentionLegals: React.FC<MentionLegalsType> = () => {
    const { t } = useTranslation();

    return (
        <div className="p-6 max-w-4xl mx-auto leading-relaxed">
            <h1 className="text-3xl font-bold mb-6 text-center">{t("legal.title")}</h1>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.editor.title")}</h2>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: t("legal.editor.site-edited-by") }} />
                    <strong> {t("legal.editor.editors")}</strong>
                    <br />
                    {t("legal.editor.email")} <a href="mailto:fastype.app@gmail.com" className="text-blue-600 underline">fastype.app@gmail.com</a>
                    <br />
                    {t("legal.editor.publication-manager")}
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.hosting.title")}</h2>
                <p>
                    {t("legal.hosting.hosted-by")}
                    <br />
                    <strong>{t("legal.hosting.company-name")}</strong>
                    <br />
                    {t("legal.hosting.address")}
                    <br />
                    {t("legal.hosting.website")}{" "}
                    <a
                        href="https://www.hostinger.fr"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline"
                    >
                        https://www.hostinger.fr
                    </a>
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.intellectual-property.title")}</h2>
                <p>
                    {t("legal.intellectual-property.content")}
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.personal-data.title")}</h2>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: t("legal.personal-data.collection") }} />
                </p>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: t("legal.personal-data.gdpr") }} />
                    <a href="mailto:fastype.app@gmail.com" className="text-blue-600 underline"> fastype.app@gmail.com</a>.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.cookies.title")}</h2>
                <p>
                    {t("legal.cookies.usage")}
                </p>
                <p>
                    {t("legal.cookies.google-policy")}{" "}
                    <a
                        href="https://policies.google.com/technologies/ads?hl=fr"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline"
                    >
                        https://policies.google.com/technologies/ads?hl=fr
                    </a>
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">{t("legal.liability.title")}</h2>
                <p>
                    {t("legal.liability.content")}
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">{t("legal.contact.title")}</h2>
                <p>
                    {t("legal.contact.content")}
                    <a href="mailto:fastype.app@gmail.com" className="text-blue-600 underline"> fastype.app@gmail.com</a>.
                </p>
            </section>
        </div>
    );
};

